import React from 'react';
import { Select } from 'antd';
import { ORDER_BY_DICTIONARY } from 'appConstants';

const SortSelect = props => {
  return (
    <Select style={{ width: 200, fontWeight: 'normal' }} {...props}>
      {Object.keys(ORDER_BY_DICTIONARY).map(key => (
        <Select.Option value={key} key={key}>
          {ORDER_BY_DICTIONARY[key].displayName}
        </Select.Option>
      ))}
    </Select>
  );
};

export default SortSelect;
